import TeamPWIcon from '../images/tools/Team-PW.png'
import NumberPWIcon from '../images/tools/Number-PW.png'
import YesNoPWIcon from '../images/tools/Yes-No-PW.png'
import LetterPWIcon from '../images/tools/Letter-PW.png'
import ImagePWIcon from '../images/tools/Image-PW.png'
import CountryPWIcon from '../images/tools/Country-PW.png'
import CountryPWBlackIcon from '../images/tools/Country-PW-black.png'
import CountryPWQuizIcon from '../images/tools/Country-PW-Quiz.png'
import CountryPWQuizBlackIcon from '../images/tools/Country-PW-Quiz-black.png'
import DatePWIcon from '../images/tools/Date-PW.png'
import ColorPWIcon from '../images/tools/Color-PW.png'
import NFLPWIcon from '../images/tools/NFL-PW.png'
import NBAPWIcon from '../images/tools/NBA-PW.png'
import MLBPWIcon from '../images/tools/MLB-PW.png'
import StatePWIcon from '../images/tools/State-PW.png'
import PWIcon from '../images/Picker-Wheel-Logo-Small.png'
import IGCommentPWIcon from '../images/tools/Instagram-Comment-PW.png'
import TruthDarePWIcon from '../images/tools/Truth-Dare-PW.png'

const ToolData = [
  {
    page: 'main',
    name: 'Picker Wheel',
    title: 'Picker Wheel',
    image: 'PickerWheel',
    description:
      'This is a random picker wheel which will spin and make a decision for you.',
    path: '/',
    icon: PWIcon,
    shortName: 'Picker Wheel',
  },
  {
    page: 'rtg',
    name: 'Team Picker Wheel',
    title: 'Team Picker Wheel',
    image: 'RTG',
    description:
      'This is a random team generator which will do grouping from a list of names.',
    path: '/tools/random-team-generator/',
    wheelPath: '/tools/random-team-wheel/',
    icon: TeamPWIcon,
    shortName: 'Team PW',
  },
  {
    page: 'ynw',
    name: 'Yes No Picker Wheel',
    title: 'Yes No Picker Wheel',
    image: 'YNW',
    description:
      'This is a random yes or no wheel which will help you to make a yes no decision.',
    path: '/tools/yes-or-no-wheel/',
    icon: YesNoPWIcon,
    shortName: 'Yes No PW',
  },
  {
    page: 'rng',
    name: 'Number Picker Wheel',
    title: 'Number Picker Wheel',
    image: 'RNG',
    description:
      'This is a rng tool which will help you to pick a number randomly.',
    path: '/tools/random-number-generator/',
    icon: NumberPWIcon,
    shortName: 'Number PW',
  },
  {
    page: 'rlg',
    name: 'Letter Picker Wheel',
    title: 'Letter Picker Wheel',
    image: 'RLG',
    description:
      'This is a random letter generator which helps to pick a random alphabet.',
    path: '/tools/random-letter-generator/',
    icon: LetterPWIcon,
    shortName: 'Letter PW',
  },
  {
    page: 'rcg',
    name: 'Country Picker Wheel',
    title: 'Country Picker Wheel',
    image: 'RCG',
    description:
      'This is a random country generator which helps to pick a random country.',
    path: '/tools/random-country-generator/',
    icon: CountryPWIcon,
    shortName: 'Country PW',
    quizIcon: CountryPWBlackIcon,
  },
  {
    page: 'rsg',
    name: 'State Picker Wheel',
    title: 'State Picker Wheel',
    image: 'RSG',
    description:
      'This is a random state generator which helps to pick a random state.',
    path: '/tools/random-state-generator/',
    icon: StatePWIcon,
    shortName: 'State PW',
  },
  {
    page: 'rcw',
    name: 'Color Picker Wheel',
    title: 'Color Picker Wheel',
    image: 'RCW',
    description:
      'This is a random color wheel which helps to pick a random color.',
    path: '/tools/random-color-generator/',
    icon: ColorPWIcon,
    shortName: 'Color PW',
  },
  {
    page: 'rig',
    name: 'Image Picker Wheel',
    title: 'Image Picker Wheel',
    image: 'RIG',
    description:
      'A random image generator which picks a random picture from pictures provided.',
    path: '/tools/random-image-generator/',
    icon: ImagePWIcon,
    shortName: 'Image PW',
  },
  {
    page: 'rdg',
    name: 'Date Picker Wheel',
    title: 'Date Picker Wheel',
    image: 'RDG',
    description:
      'This is a random date generator which helps to pick a random date.',
    path: '/tools/random-date-generator/',
    icon: DatePWIcon,
    shortName: 'Date PW',
  },
  {
    page: 'icp',
    name: 'Instagram Comment Picker Wheel',
    title: ['Instagram Comment', 'Picker Wheel'],
    image: 'ICP',
    description: 'This is an Instagram giveaway generator.',
    path: '/tools/instagram-comment-picker/',
    icon: IGCommentPWIcon,
    shortName: 'IG Comment PW',
  },
  {
    page: 'mlb',
    name: 'MLB Picker Wheel',
    title: 'MLB Picker Wheel',
    image: 'MLB',
    description:
      'This is a MLB team wheel which helps to pick a random MLB team.',
    path: '/tools/random-mlb-team-generator/',
    icon: MLBPWIcon,
    shortName: 'MLB PW',
  },
  {
    page: 'nba',
    name: 'NBA Picker Wheel',
    title: 'NBA Picker Wheel',
    image: 'NBA',
    description:
      'This is a NBA team wheel which helps to pick a random NBA team.',
    path: '/tools/random-nba-team-generator/',
    icon: NBAPWIcon,
    shortName: 'NBA PW',
  },
  {
    page: 'nfl',
    name: 'NFL Picker Wheel',
    title: 'NFL Picker Wheel',
    image: 'NFL',
    description:
      'This is a NFL team wheel which helps to pick a random NFL team.',
    path: '/tools/random-nfl-team-generator/',
    icon: NFLPWIcon,
    shortName: 'NFL PW',
  },
  {
    page: 'cfq',
    name: 'Flag Quiz Picker Wheel',
    title: 'Flag Quiz Picker Wheel',
    image: 'CFQ',
    description:
      'This is a country flag quiz that test your knowledge of country flags and names.',
    path: '/tools/country-flag-quiz/',
    icon: CountryPWQuizIcon,
    shortName: 'Flag Quiz Picker Wheel',
    quizIcon: CountryPWQuizBlackIcon,
  },
  {
    page: 'tdq',
    name: 'Truth or Dare Picker Wheel',
    title: 'Truth or Dare Picker Wheel',
    image: 'TDQ',
    description:
      'This is a random truth or dare generator which helps to pick a random question.',
    path: '/tools/truth-or-dare-questions/',
    icon: TruthDarePWIcon,
    shortName: 'Truth or Dare PW',
  },
]

export default ToolData
